angular.module('gym.contacts').controller('ShowContactWaiverCtrl', ["$scope", "$rootScope", "waiver", function($scope, $rootScope, waiver) {
  $scope.waiver = waiver.plain();
  $scope.currency = $rootScope.gym.currency_symbol;
  return $scope.membershipSettingsChanged = function() {
    if (waiver.review_status === 'Pending Consent') {
      return 'Yes (pending consent from signee)';
    }
    if (waiver.consent_given) {
      return 'Yes (consent given by signee)';
    }
    if (waiver.skip_consent_reason) {
      return `Yes (consent process skipped; reason: ${waiver.skip_consent_reason})`;
    }
    return 'No';
  };
}]);
